import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader } from 'lucide-react';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const maxAttempts = 10;

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    }
  }, [sessionId, attempts]);

  const pollPaymentStatus = async () => {
    if (attempts >= maxAttempts) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await axios.get(`${API}/payments/status/${sessionId}`);
      
      if (response.data.payment_status === 'paid') {
        setStatus('success');
      } else if (response.data.status === 'expired') {
        setStatus('expired');
      } else {
        setTimeout(() => setAttempts(prev => prev + 1), 2000);
      }
    } catch (error) {
      console.error('Error checking payment status', error);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50" data-testid="payment-success-page">
      <Card className="w-full max-w-md card">
        <CardHeader className="text-center">
          {status === 'checking' && (
            <>
              <div className="flex justify-center mb-4">
                <Loader className="w-16 h-16 text-teal-600 animate-spin" />
              </div>
              <CardTitle className="text-2xl">Vérification du Paiement...</CardTitle>
              <p className="text-gray-600 mt-2">Veuillez patienter pendant que nous confirmons votre abonnement</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircle className="w-10 h-10 text-green-600" />
                </div>
              </div>
              <CardTitle className="text-2xl text-green-600" data-testid="success-message">Paiement Réussi!</CardTitle>
              <p className="text-gray-600 mt-2">Votre abonnement a été activé. Vous êtes maintenant visible aux patients.</p>
            </>
          )}
          
          {(status === 'error' || status === 'expired' || status === 'timeout') && (
            <>
              <CardTitle className="text-2xl text-red-600">Problème de Paiement</CardTitle>
              <p className="text-gray-600 mt-2">
                {status === 'expired' && 'Votre session de paiement a expiré.'}
                {status === 'timeout' && 'La vérification du paiement a expiré. Veuillez vérifier votre tableau de bord.'}
                {status === 'error' && 'Une erreur s\'est produite lors de la vérification de votre paiement.'}
              </p>
            </>
          )}
        </CardHeader>
        
        <CardContent>
          <Button
            onClick={() => navigate('/doctor-dashboard')}
            className="w-full btn-primary"
            disabled={status === 'checking'}
            data-testid="go-to-dashboard-btn"
          >
            Aller au Tableau de Bord
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;